import { type Ref, defineNuxtPlugin, h, ref, useSlots, watchEffect } from "@nuxtjs/composition-api";
import Vue from "vue";
import type VueI18n from "vue-i18n";

import { useTranslate } from "@/composables";

declare module "vue/types/vue" {
  interface Vue {
    $gettext: VueI18n["t"];
  }
}

declare module "@nuxt/types" {
  interface Context {
    $gettext: VueI18n["t"];
  }
}

Vue.component("Translate", {
  props: {
    tag: {
      type: String,
      default: "span",
    },
  },
  setup(props) {
    const wrap: Ref<HTMLSpanElement | null> = ref(null);
    const { t } = useTranslate();
    const slots = useSlots();
    const txt = t(slots.default?.()[0].text ?? "");

    watchEffect(() => wrap.value && (wrap.value.textContent = txt.value));

    return () =>
      h(
        props.tag,
        {
          ref: wrap,
        },
        slots.default?.(),
      );
  },
});

/**
 * Creates aliases of i18n's t method under gettext
 * and stubs the translate component
 */
const plugin = defineNuxtPlugin((context, inject) => {
  inject("gettext", context.i18n.t.bind(context.i18n));

  // TODO: Remove with CW refactor
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  context.$gettext = context.i18n.t.bind(context.i18n);
});

export default plugin;
